import { useState } from 'react';

import { Add } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import { Button, IconButton, Typography } from '@mui/material';

import { CustomInput } from 'src/components/CustomInput';

import { Flex } from '../Flex';

type EditInputProps = {
    onChange: (value: string) => void;
    title: string;
    placeholder?: string;
    name: string;
    onUpdate: () => Promise<void>;
    value: string | null;
};

export const EditInput = ({
    onChange,
    title,
    placeholder,
    name,
    onUpdate,
    value,
}: EditInputProps) => {
    const [isEditing, setIsEditing] = useState(value === null);
    return (
        <>
            {!isEditing && (
                <Flex justifyContent={'end'}>
                    <IconButton
                        size="small"
                        sx={{
                            color: 'grey',
                            '&:hover': { background: 'none', color: 'black' },
                        }}
                        onClick={() => setIsEditing(!isEditing)}
                    >
                        <EditIcon />
                    </IconButton>
                </Flex>
            )}

            <Typography
                fontWeight="500"
                fontSize="24px"
                lineHeight="34px"
                color="#1D1D1B"
                marginBottom="2px"
            >
                {title}
            </Typography>
            <CustomInput
                name={name}
                value={value}
                onChange={({ target }) => {
                    onChange(target.value);
                }}
                disabled={!isEditing}
                placeholder={placeholder}
            />
            {isEditing && (
                <Flex width="100%" justifyContent="end">
                    <Button
                        startIcon={<Add />}
                        variant="npi-primary"
                        sx={{
                            width: '64px',
                            '& .MuiButton-startIcon': {
                                marginRight: 0,
                            },
                        }}
                        disabled={!isEditing || !value}
                        onClick={async () => {
                            await onUpdate();
                            setIsEditing(false);
                        }}
                    >
                        Add
                    </Button>
                </Flex>
            )}
        </>
    );
};
